// extracted by mini-css-extract-plugin
export default {"box":"SliderNote_box__GqJ8c","positionLeft":"SliderNote_positionLeft__vqyXs","positionRight":"SliderNote_positionRight__2mLeQ","btn":"SliderNote_btn__1LvRf"};